import { getLabelStyles } from '@sharedCR/common/form/Label';

import { COLOR_PALETTE } from 'constants/ui';

import { getContactAvatarColor } from '../crmContact.utils';

export const sectionStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '16px',
};

export const headingStyles = {
  ...getLabelStyles(),
  letterSpacing: '0.1px',
};

// customStyles for the shared Avatar: the contact's deterministic CRM color
// (matching the borrowers-grid indicator) with white initials at the given size.
export const getContactAvatarStyles = ({ contact, size }) => ({
  width: `${size}px`,
  height: `${size}px`,
  border: 'none',
  color: COLOR_PALETTE.GRAY[1],
  backgroundColor: getContactAvatarColor(contact),
});
